import Alert from '../components/common/Alert';
import { mlSheetService } from '../services/mlSheetService';
import { downloadBlob } from './downloadBlob';
import { downloadPdfBlob, printPdfBlob, parseBlobErrorMessage } from './printPdfBlob';
import { printHtmlInFrame } from './printShipmentReceipt';

export async function downloadMlSheetInvoices(mlSheetId, paymentMode) {
  const response = await mlSheetService.bulkInvoices(mlSheetId, paymentMode);
  const saved = await downloadPdfBlob(response.data, `invoices_${mlSheetId}.pdf`);
  if (saved?.method === 'cancelled') return;
  Alert.success('Invoices downloaded');
}

export async function printMlSheetInvoices(mlSheetId, paymentMode) {
  const response = await mlSheetService.bulkInvoices(mlSheetId, paymentMode);
  const result = await printPdfBlob(response.data, `invoices_${mlSheetId}.pdf`);
  if (result?.method === 'blocked') {
    Alert.error('Could not open the print dialog');
  }
}

export async function downloadMlSheetReceipts(mlSheetId, paymentMode) {
  const response = await mlSheetService.bulkReceipts(mlSheetId, paymentMode);
  const saved = await downloadBlob(
    response.data,
    `receipts_${mlSheetId}.html`,
    'text/html',
  );
  if (saved?.method === 'cancelled') return;
  Alert.success('Receipts downloaded');
}

export async function printMlSheetReceipts(mlSheetId, paymentMode) {
  const response = await mlSheetService.bulkReceipts(mlSheetId, paymentMode);
  const html = await response.data.text();
  const printed = await printHtmlInFrame(html, `Receipts ${mlSheetId}`);
  if (printed === 'cancelled') return;
  if (!printed) Alert.error('Could not open the print dialog');
}
